import KizenTypography from 'app/kizentypo';
import ActionMenu from 'components/AccessRequests/Tables/Cells/ActionMenu';
import { ActiveToggleCell } from 'components/AccessRequests/Tables/Cells/ActiveToggle';
import EditableName from 'components/AccessRequests/Tables/Cells/EditableName';
import OwnerDropdown from 'components/AccessRequests/Tables/Cells/OwnerDropdown';
import SharingSettingsCell from 'components/AccessRequests/Tables/Cells/SharingSettingsCell';
import { COLUMN_SIZES, EMPLOYEE_ACCESS } from 'components/AccessRequests/utils';

// These columns are mostly stubs and will be wired up in a future PR
export const getColumns = (canEdit, canDelete, t) => [
  {
    name: t('Homepage Name'),
    id: 'name',
    width: COLUMN_SIZES.LARGE,
    accessor: (data, opts) => {
      return (
        <EditableName
          access={data.employee_access}
          canEdit={canEdit}
          id={data.id}
          name={data.name}
          {...opts}
        />
      );
    },
    truncate: true,
    qaField: 'homepage-name',
    shrinkable: true,
  },
  {
    name: t('Creator'),
    id: 'creator',
    width: COLUMN_SIZES.MEDIUM,
    accessor: (data, opts) => (
      <OwnerDropdown id={data.id} data={data} {...opts} canEdit={canEdit} />
    ),
    truncate: false,
    qaField: 'homepage-owner',
    shrinkable: true,
  },
  {
    name: t('Homepage Assignments'),
    id: 'assignments',
    width: COLUMN_SIZES.SMALL,
    accessor: (data, opts) => (
      <SharingSettingsCell
        onClickEdit={opts.editHandler}
        access={data.employee_access}
        data={data}
        hideRoles={[EMPLOYEE_ACCESS.EDIT]}
        canEdit={canEdit}
      />
    ),
    qaField: 'homepage-assignments',
    shrinkable: true,
  },
  {
    name: t('Active?'),
    id: 'active',
    width: COLUMN_SIZES.TINY,
    accessor: (data, opts) => <ActiveToggleCell data={data} {...opts} />,
    qaField: 'homepage-active',
  },
  {
    name: t('# Blocks'),
    id: 'count',
    width: COLUMN_SIZES.TINY,
    accessor: (data) => (
      <KizenTypography>{data?.dashlets_count ?? 0}</KizenTypography>
    ),
    qaField: 'homepage-blocks-count',
  },
  {
    name: t('Actions'),
    id: 'actions',
    accessor: (data, opts) => (
      <ActionMenu
        access={data.employee_access}
        hidden={data.hidden}
        canEdit={canEdit}
        canDelete={canDelete}
        {...opts}
      />
    ),
    align: 'right',
    qaField: 'homepage-actions',
  },
];
